import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { AssetsScoreDistribution } from "./ChartTypes/AssetsScoreDistribution";
import { OwnershipConcentration } from "./ChartTypes/OwnershipConcentration";
import { Average3DaysMarketCap } from "./ChartTypes/Average3DaysMarketCap";
import { Average3MonthsVolume } from "./ChartTypes/Average3MonthsVolume";
import { getGetAssetListingStatisticsThunk } from "../../../Thunks";
import { ThreeMonthsVolume } from "./ChartTypes/ThreeMonthsVolume";
import { ProjectMaturity } from "./ChartTypes/ProjectMaturity";
import { HistoricalRisk } from "./ChartTypes/HistoricalRisk";
import { ProjectRisk } from "./ChartTypes/ProjectRisk";
import { AMLActivity } from "./ChartTypes/AMLActivity";
import { KPIChanges } from "./ChartTypes/KPIChanges";
import { LawSuits } from "./ChartTypes/Lawsuits";
import { Header, LogoLoading } from "../../../Components";
import styles from "./statistics.module.css";
import { Flex } from "antd";

export function customTooltipHandlerFull(context, value, percent) {
  let tooltipEl = document.getElementById("chart-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chart-tooltip";
    tooltipEl.className = styles.customTooltip;
    document.body.appendChild(tooltipEl);
  }

  const tooltip = context.tooltip;
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  tooltipEl.innerHTML = `
    <div class="${styles.tooltipContent}">
      <div class="${styles.tooltipValue}">${Number(value).toFixed(
    0
  )} / ${percent}%</div>
    </div>
  `;

  const canvasRect = context.chart.canvas.getBoundingClientRect();
  const left = canvasRect.left + window.scrollX + tooltip.caretX + 12;
  const top =
    canvasRect.top +
    window.scrollY +
    tooltip.caretY -
    tooltipEl.offsetHeight / 2;

  tooltipEl.style.opacity = 1;
  tooltipEl.style.width = "100px";
  tooltipEl.style.position = "absolute";
  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
  tooltipEl.style.pointerEvents = "none";
}
export function customTooltipHandler(context, value) {
  let tooltipEl = document.getElementById("chart-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chart-tooltip";
    tooltipEl.className = styles.customTooltip;
    document.body.appendChild(tooltipEl);
  }

  const tooltip = context.tooltip;

  if (!tooltip || tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }
  tooltipEl.innerHTML = `
    <div class="${styles.tooltipContent}">
      <div class="${styles.tooltipValue}">${value}</div>
    </div>
  `;
  const rect = context.chart.canvas.getBoundingClientRect();

  tooltipEl.style.opacity = 1;
  tooltipEl.style.position = "absolute";
  tooltipEl.style.left =
    rect.left + window.scrollX + tooltip.caretX + 30 + "px";
  tooltipEl.style.top = rect.top + window.scrollY + tooltip.caretY + "px";
}
export const formatDateWithDots = (isoDate) => {
  const d = new Date(isoDate);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};
export function formatNumber(n) {
  if (n >= 1000) return (n / 1000).toFixed(1).slice(0, 4) + "k";
  return Number(n).toPrecision(3);
}
export function Statistics() {
  const dispatch = useDispatch();
  const assetUserStatistics = useSelector((state) => {
    return state.ListingReducer.assetsUserStatistics;
  });

  useEffect(() => {
    dispatch(getGetAssetListingStatisticsThunk());
  }, []);

  return (
    <>
      <Header title={"Assets Insight Analytics"} />
      {
        !Object.keys(assetUserStatistics)?.length ?
          <Flex style={{ width: '100%', height: '100vh' }} align="center" justify="center"><LogoLoading className='logo-loading' /></Flex>
          :
          <main className={`listening_main_wrapper ${styles.statisticsWrapper}`}>
            <div className={styles.statisticsElement}>
              <AssetsScoreDistribution
                assetsScoreDistribution={
                  assetUserStatistics.assetsScoreDistribution
                }
              />
            </div>
            <div className={styles.statisticsElement}>
              <KPIChanges
                kpiChangesInTheLast30Days={
                  assetUserStatistics?.kpiChangesInTheLast30Days
                }
              />
            </div>
            <div
              className={`${styles.statisticsElement} ${styles.statisticsFullElement}`}
              style={{ height: "500px" }}
            >
              <ThreeMonthsVolume
                threeMonthsVolume={assetUserStatistics?.threeMonthsVolume}
              />
              <Average3MonthsVolume
                threeMonthsVolumeAvg={assetUserStatistics?.threeMonthsVolumeAvg}
              />
            </div>
            <div className={styles.statisticsElement} style={{ height: "400px" }}>
              <Average3DaysMarketCap
                avgMarketCapMonthAgo={assetUserStatistics?.avgMarketCapMonthAgo}
              />
            </div>
            <div className={styles.statisticsElement} style={{ height: "400px" }}>
              <OwnershipConcentration
                ownershipConcentration={assetUserStatistics?.ownershipConcentration}
              />
            </div>
            <div className={styles.statisticsElement} style={{ height: "500px" }}>
              <ProjectMaturity
                projectMaturity={assetUserStatistics?.projectMaturity}
              />
            </div>
            <div className={styles.statisticsElement} style={{ height: "500px" }}>
              <ProjectRisk projectRisk={assetUserStatistics?.projectRisk} />
            </div>
            <div className={styles.statisticsElement} style={{ height: "500px" }}>
              <HistoricalRisk
                historicalRisk={assetUserStatistics?.historicalRisk}
              />
            </div>
            <div className={styles.statisticsElement} style={{ height: "500px" }}>
              <AMLActivity amlActivity={assetUserStatistics?.amlActivity} />
            </div>
            <div className={styles.statisticsElement} style={{ height: "500px" }}>
              <LawSuits lawSuits={assetUserStatistics?.lawsuits} />
            </div>
          </main>
      }
    </>
  );
}
